import Vue from 'vue';
import Vuex from 'vuex';
import consts from '../services/consts';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        granularToday: {},
        generalToday: {},
        energy: {
            today: 0,
            year: 0,
            total: 0,
        },
        money: {
            today: 0,
            total: 0,
        },
        co2: {
            total: 0,
        },
    },
    mutations: {
        setGranular (state, granular) {
            state.granularToday = granular;
        },
        setGeneral (state, generalData) {
            state.generalToday = generalData;

            state.energy.current = generalData.current;
            state.energy.today = generalData.today ? (generalData.today /
                1000).toFixed(2) : 0;
            state.energy.total = generalData.total ? (generalData.total /
                (1000 * 1000)).toFixed(2) : 0;

            state.money.today = generalData.today ? ((generalData.today *
                consts.KW_2_EUR / 1000)).toFixed(2) : 0;
            state.money.total = generalData.total ? ((generalData.total /
                (1000) * consts.KW_2_EUR)).toFixed(2) : 0;

            state.co2.total = generalData.total
                ? ((generalData.total) * consts.KW_CO_2_VAL / 1000).toFixed(2)
                : 0;
        },
    },
});